/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportResistanceDtoResistance =
  (typeof LabReportResistanceDtoResistance)[keyof typeof LabReportResistanceDtoResistance];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportResistanceDtoResistance = {
  SENSIBLE: 'SENSIBLE',
  RESISTENT: 'RESISTENT',
  INTERMEDIATE: 'INTERMEDIATE',
} as const;
